import React from 'react';
import { motion } from 'framer-motion';

export default function SoftwarePage() {
    return (
        <div style={{ background: 'var(--bg-page)', minHeight: '100vh', padding: '120px 40px', color: 'var(--text-primary)' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
                <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{ fontSize: '48px', fontWeight: '600', marginBottom: '24px' }}>
                    Software Hubs
                </motion.h1>
                <p style={{ fontSize: '20px', color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto 60px' }}>
                    Explore our QA Hub and Operations Hub designed to protect your revenue and streamline workflows.
                </p>
            </div>
        </div>
    );
}
